<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field name="code" label="Code" type="text" v-model="queryParams.code"></v-text-field>
            </v-flex>
            <v-flex sm4 v-if="this.user.role.roleName != 'BRANCH_ADMIN'">
              <shop-autocomplete
                :param="Number(queryParams.shopId)"
                @set="setShop"
              />
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="incomeStatementList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :must-sort="true"
                  >
                  <template slot="items" slot-scope="props">
                    <td>
                      <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <v-btn flat icon color="blue lighten-2" @click="print(props.item.id)">
                        <v-icon>print</v-icon>
                      </v-btn>
                      <v-btn flat icon color="blue lighten-2" @click="exportIncomeStatement(props.item.id)">
                        <v-icon>description</v-icon>
                      </v-btn>
                    </td>
                    <td>{{ props.item.code }}</td>
                    <td>{{ props.item.shop.code }}</td>
                    <td>{{ props.item.year }}</td>
                    <td>{{ props.item.month }}</td>
                    <td>{{ props.item.createdDateInMilliSeconds | format-ms-date-time }}</td>
                    <td>{{ props.item.createdBy }}</td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- IS print hidden area -->

    <div id="incomestatementPrint" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center;padding-bottom:5px">
        <p
          style="font-size:15px;margin:0px;font-weight:bold;"
          v-if="incomeStatement.shop"
        >{{ incomeStatement.shop.name }}</p>
      </div>

      <div style="text-align:center">
        <p
          style="font-size:15px;margin:0px"
        >Statement Of Profit Or Loss</p>
      </div>
      <div style="float:left;padding-left:11px">
        <p
          style="font-size:15px;margin:0px"
          id="counter"
        >Income Statement Code : {{incomeStatement.code}}</p>
      </div>
      <div style="float:right;padding-right:11px">
        <p style="font-size:15px;margin:0px" id="counter"></p>
      </div>
      <br />
      <div style="float:left;padding-left:11px">
        <p
          style="font-size:15px;margin:0px"
          id="counter"
          v-if="incomeStatement.shop"
        >Shop Code: {{ incomeStatement.shop.code }}</p>
      </div>
      <div style="float:right;padding-right:11px">
        <p
          style="font-size:15px;margin:0px"
          id="counter"
        >Created Date : {{ incomeStatement.createdDateInMilliSeconds | format-ms-date }}</p>
      </div>
      <br />
      <div style="float:left;padding-left:11px">
        <p style="font-size:15px;margin:0px" id="casher">Date : {{ incomeStatement.year }}, {{ incomeStatement.month }}</p>
      </div>
      <div style="float:right;padding-right:11px">
        <p style="font-size:15px;margin:0px" id="counter">Created By : {{incomeStatement.createdBy}}</p>
      </div>
      <br />

      <div style="clear:both"></div>
      <div style="height:10px"></div>
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr style="line-height: 20px;">
              <th style="border:1px solid black;text-align:center">Account Code</th>
              <th style="border:1px solid black;text-align:center">Account Name</th>
              <th style="border:1px solid black;text-align:center">SubAccount Amount</th>
              <th style="border:1px solid black;text-align:center">Amount</th>
              <th style="border:1px solid black;text-align:center">Total Amount</th>
            </tr>
          </thead>
          <!-- start net sale -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              class="font-weight-black"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >REVENUE</td>
          </tr>
          <tbody
            v-for="(item, index) in incomeStatement.incomeStatementAccountList"
            :key="'a'+index"
          >
          <tbody v-if="item.sessionName == 'REVENUE'">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.totalAmount | decFormat(6)}})</span>
                <span v-else>{{item.totalAmount | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <!-- for sub account -->
            <tr v-for="(itemdetail, index) in item.incomeStatementDetailList"
            :key="'ad'+index" style="line-height: 20px;">
            <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">{{itemdetail.amount | decFormat(6)}}</td>
              <td style="border:1px solid black;text-align:right"></td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <!-- end sub account -->
            </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Net Sale</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{incomeStatement.totalRevenue | decFormat(6)}}</td>
          </tr>
          <!-- end net sale -->
          <!-- start cost of good sold -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              class="font-weight-black"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >COST OF GOOD SOLD</td>
          </tr>
          <tbody
            v-for="(item, index) in incomeStatement.incomeStatementAccountList"
            :key="'b'+index"
          >
          <tbody v-if="item.sessionName == 'COST_OF_GOOD_SOLD'">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.totalAmount | decFormat(6)}})</span>
                <span v-else>{{item.totalAmount | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
             <tr v-for="(itemdetail, i) in item.incomeStatementDetailList"
            :key="'bd'+i" style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                {{itemdetail.amount | decFormat(6)}}</td>
              <td style="border:1px solid black;text-align:right"></td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Cost Of Sale</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{incomeStatement.totalCostOfGoodSold | decFormat(6)}}</td>
          </tr>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Gross Profit</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{incomeStatement.grossProfit | decFormat(6)}}</td>
          </tr>
          <!-- end cost of good sold -->
          <!-- start other income -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              class="font-weight-black"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >OTHER INCOME</td>
          </tr>
          <tbody
            v-for="(item, index) in incomeStatement.incomeStatementAccountList"
            :key="'c'+index"
          >
          <tbody v-if="item.sessionName == 'OTHER_INCOME'">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.totalAmount | decFormat(6)}})</span>
                <span v-else>{{item.totalAmount | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <tr v-for="(itemdetail, i) in item.incomeStatementDetailList"
            :key="'cd'+i" style="line-height: 20px;">
            <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                {{itemdetail.amount | decFormat(6)}}</td>
              <td style="border:1px solid black;text-align:right"></td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Other Income</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{incomeStatement.totalOtherIncome | decFormat(6)}}</td>
          </tr>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Income</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{incomeStatement.grossProfit+incomeStatement.totalOtherIncome | decFormat(6)}}</td>
          </tr>
          <!-- end other income -->
          <!-- start administration expense -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              class="font-weight-black"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >ADMINISTRATION EXPENSES</td>
          </tr>
          <tbody
            v-for="(item, index) in incomeStatement.incomeStatementAccountList"
            :key="'d'+index" style="line-height: 20px;"
          >
          <tbody v-if="item.sessionName == 'ADMINISTRATION_EXPENSES'">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.totalAmount | decFormat(6)}})</span>
                <span v-else>{{item.totalAmount | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <tr v-for="(itemdetail, i) in item.incomeStatementDetailList"
            :key="'cd'+i" style="line-height: 20px;">
            <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                {{itemdetail.amount | decFormat(6)}}</td>
              <td style="border:1px solid black;text-align:right"></td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Administration Expense</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{incomeStatement.totalAdministrationExpense | decFormat(6)}}</td>
          </tr>
          <!-- end administration expnese -->
          <!-- start selling and distribution expense -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              class="font-weight-black"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >SELLING & DISTRIBUTION EXPENSES</td>
          </tr>
          <tbody
            v-for="(item, index) in incomeStatement.incomeStatementAccountList"
            :key="'i'+index"
          >
          <tbody v-if="item.sessionName == 'SELLING_DISTRIBUTION_EXPENSES'">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.totalAmount | decFormat(6)}})</span>
                <span v-else>{{item.totalAmount | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <tr v-for="(itemdetail, i) in item.incomeStatementDetailList"
            :key="'cd'+i" style="line-height: 20px;">
            <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                {{itemdetail.amount | decFormat(6)}}</td>
              <td style="border:1px solid black;text-align:right"></td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Selling & Distribution Expenses</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{incomeStatement.totalSellingAndDistributionExpense | decFormat(6)}}</td>
          </tr>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Expense</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{incomeStatement.totalAdministrationExpense+incomeStatement.totalSellingAndDistributionExpense | decFormat(6)}}</td>
          </tr>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Net Profit Before Tax</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{incomeStatement.profitLossAmount | decFormat(6)}}</td>
          </tr>
          <!-- end selling and distribution expense -->
          <!-- start P & L Appropriation -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              class="font-weight-black"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >P & L Appropriation</td>
          </tr>
          <tbody
            v-for="(item, index) in incomeStatement.incomeStatementAccountList"
            :key="'i'+index"
          >
          <tbody v-if="item.sessionName == 'P_L_APPROPRIATION'">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.parentAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.totalAmount | decFormat(6)}})</span>
                <span v-else>{{item.totalAmount | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <tr v-for="(itemdetail, i) in item.incomeStatementDetailList"
            :key="'cd'+i" style="line-height: 20px;">
            <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                {{itemdetail.amount | decFormat(6)}}</td>
              <td style="border:1px solid black;text-align:right"></td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Closing Retained Earning</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{incomeStatement.closingRetainedEarning | decFormat(6)}}</td>
          </tr>
        </table>
        <div style="height:10px"></div>
      </div>
    </div>

    <!-- End print  -->
  </v-container>
</template>
<script>
import ShopAutocomplete from "../templates/ShopAutocomplete.vue";
import { incomeStatementService } from "../../services/income-statement-service";
import { IncomeStatement } from "../../models/model";
import { commonService } from "../../services/common-service";
export default {
  name: "IncomeStatementList",
  components: { ShopAutocomplete },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Income Statement",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "name", align: "left", sortable: false },
      { text: "Income Statement Code", align: "left", value: "code" },
      { text: "Shop Code", value: "shopCode" },
      { text: "Year", value: "year" },
      { text: "Month", value: "month" },
      { text: "Created Date", value: "createdDate" },
      { text: "Created By", value: "createdBy" },
    ],
    rowsPerPageItems: [25, 50, 100],
    decimalFormat: "",
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    incomeStatementList: [],
    totalRows: 0,

    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      code: "",
      shopId: "",
    },
    incomeStatement: new IncomeStatement(),
  }),
  watch: {
    pagination: {
      handler() {
        this.getIncomeStatementList();
      },
      deep: true,
    },
  },

  created() {
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.decimalFormat = commonService.formatdecimal();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      if (this.user.role.roleName == "BRANCH_ADMIN") {
        this.queryParams.shopId = this.user.shopId;
      }
      this.$router.replace({
        name: "income-statements",
        query: this.queryParams,
      });
      this.getIncomeStatementList();
    },
    setShop(obj) {
      this.queryParams.shopId = obj.shopId;
    },
    getIncomeStatementList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      incomeStatementService
        .getIncomeStatementList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.incomeStatementList = res.data.incomeStatementList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onEdit(incomeStatement) {
      // go to details page
      this.$router.push("/income-statement/" + incomeStatement.id);
    },
    print(id) {
      incomeStatementService
        .getIncomeStatementById(id)
        .then((res) => {
          this.incomeStatement = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printInvoice("incomestatementPrint");
        });
    },
    printInvoice(divName) {
      var printContents = document.getElementById(divName).innerHTML;

      // var originalContents = document.body.innerHTML;
      var myWindow = window.open("", "MsgWindow", "width=350,height=500");
      myWindow.document.write(printContents);

      // document.body.innerHTML = printContents;
      myWindow.print();

      // document.body.innerHTML = originalContents;
      myWindow.close();
    },
    exportIncomeStatement(id){
      incomeStatementService
        .exportIncomeStatement(id)
        .then(res => {
          commonService.downloadE(res);
        });
    }
  },
};
</script>